import React from 'react'

import HighlightPublications from '/react4xp/components/pages/highlight-publications'

function SearchPublicationsPart(props: any) {
    return (
        <HighlightPublications {...props} />
    )
}

export default (props) => <SearchPublicationsPart {...props} />
